type IconProps = {
  color?: string;
  hide?: boolean;
  width?: number | string;
  height?: number;
  size?: number;
};

export const DropdownChevron = ({
  color = '#888',
  hide = false,
  size = 15,
}: IconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    {!hide && (
      <path
        d="M5.5 6.5L7.5 8.5L9.5 6.5"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    )}
  </svg>
);

export const CheckIcon = ({ color = '#888' }: IconProps) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path
      d="M4.5 11.5L7.5 14.5L16.5 5.5"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const CheckInvalidIcon = ({ color = '#888' }: IconProps) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path d="M5 10 H15" stroke={color} strokeLinecap="round" strokeWidth="2" />
  </svg>
);

export const CloseIcon = ({ color = '#888' }: IconProps) => (
  <svg width="15" height="15" viewBox="0 0 15 15">
    <path
      d="M11.7426 11.0355L8.20719 7.50008L11.7427 3.96454C11.9379 3.76938 11.9379 3.4526 11.7427 3.25744C11.5476 3.06227 11.2308 3.06227 11.0356 3.25744L7.50009 6.79297L3.96447 3.25735C3.7693 3.06219 3.45252 3.06219 3.25736 3.25735C3.0622 3.45251 3.0622 3.7693 3.25736 3.96446L6.79298 7.50008L3.25745 11.0356C3.06228 11.2308 3.06228 11.5476 3.25745 11.7427C3.45261 11.9379 3.76939 11.9379 3.96455 11.7427L7.50009 8.20718L11.0355 11.7426C11.2307 11.9378 11.5475 11.9378 11.7426 11.7426C11.9378 11.5475 11.9378 11.2307 11.7426 11.0355Z"
      fill={color}
    />
  </svg>
);

export const CopyLinkIcon = ({ color = '#888' }: IconProps) => (
  <svg width="15" height="15" viewBox="0 0 15 15" fill="none">
    <rect x="5" y="5" width="7" height="7" rx="1" stroke={color} />
    <path
      d="M3.5 10V3.5H10"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ChevronLeftIcon = ({ color = '#888' }: IconProps) => (
  <svg width="15" height="15" viewBox="0 0 15 15" fill="none">
    <path
      d="M9 3.5L5 7.5L9 11.5"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ChevronRightIcon = ({ color = '#888' }: IconProps) => (
  <svg width="15" height="15" viewBox="0 0 15 15" fill="none">
    <path
      d="M6 3.5L10 7.5L6 11.5"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const DisableIcon = ({ color = '#888' }: IconProps) => (
  <svg width="15" height="15" viewBox="0 0 15 15" fill="none">
    <circle cx="7.5" cy="7.5" r="5" stroke={color} />
    <path d="M4 11L11 4" stroke={color} strokeLinecap="round" />
  </svg>
);

export const ChartIcon = ({ color = '#888' }: IconProps) => (
  <svg width="15" height="15" viewBox="0 0 15 15" fill="none">
    <path
      d="M3.5 11.5V8M7.5 11.5V4M11.5 11.5V6.5"
      stroke={color}
      strokeLinecap="round"
    />
  </svg>
);

export const EnableIcon = ({ color = '#888' }: IconProps) => (
  <svg width="15" height="15" viewBox="0 0 15 15" fill="none">
    <circle cx="7.5" cy="7.5" r="5" stroke={color} />
    <path
      d="M5.3 7.7L6.9 9.3L9.8 6"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const TrashIcon = ({ color = '#888' }: IconProps) => (
  <svg width="15" height="15" viewBox="0 0 15 15" fill="none">
    <path d="M3 4.5H12" stroke={color} strokeLinecap="round" />
    <path
      d="M6 4.5V3.5C6 3.22386 6.22386 3 6.5 3H8.5C8.77614 3 9 3.22386 9 3.5V4.5"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.5 4.5L5 11.6C5.02 11.96 5.31 12.24 5.67 12.24H9.33C9.69 12.24 9.98 11.96 10 11.6L10.5 4.5"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const PinIcon = ({
  color = '#888',
  width = 15,
  height = 15,
}: IconProps) => (
  <svg width={width} height={height} viewBox="0 0 15 15">
    <mask id="path-1-inside-1" fill="white">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.5 15C8.5 15 13 10 13 5.5C13 2.46243 10.5376 0 7.5 0C4.46243 0 2 2.46243 2 5.5C2 10 6.5 15 7.5 15ZM7.5 7C8.32843 7 9 6.32843 9 5.5C9 4.67157 8.32843 4 7.5 4C6.67157 4 6 4.67157 6 5.5C6 6.32843 6.67157 7 7.5 7Z"
      />
    </mask>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.5 15C8.5 15 13 10 13 5.5C13 2.46243 10.5376 0 7.5 0C4.46243 0 2 2.46243 2 5.5C2 10 6.5 15 7.5 15ZM7.5 7C8.32843 7 9 6.32843 9 5.5C9 4.67157 8.32843 4 7.5 4C6.67157 4 6 4.67157 6 5.5C6 6.32843 6.67157 7 7.5 7Z"
      fill={color}
      fillOpacity="0.15"
    />
    <path
      d="M12 5.5C12 7.45393 11.0044 9.626 9.80179 11.3698C9.21003 12.2278 8.59678 12.9402 8.08934 13.4264C7.83394 13.6712 7.62295 13.8417 7.4696 13.9437C7.39281 13.9948 7.34768 14.0171 7.33218 14.0238C7.30541 14.0353 7.37164 14 7.5 14V16C7.75336 16 7.97194 15.9256 8.12094 15.8617C8.28122 15.7929 8.43532 15.7034 8.57728 15.609C8.86142 15.42 9.16606 15.1647 9.47316 14.8704C10.0907 14.2786 10.79 13.4597 11.4482 12.5052C12.7456 10.624 14 8.04607 14 5.5H12ZM7.5 1C9.98528 1 12 3.01472 12 5.5H14C14 1.91015 11.0899 -1 7.5 -1V1ZM3 5.5C3 3.01472 5.01472 1 7.5 1V-1C3.91015 -1 1 1.91015 1 5.5H3ZM7.5 14C7.62836 14 7.69459 14.0353 7.66782 14.0238C7.65232 14.0171 7.60719 13.9948 7.5304 13.9437C7.37705 13.8417 7.16606 13.6712 6.91066 13.4264C6.40322 12.9402 5.78997 12.2278 5.19821 11.3698C3.99562 9.626 3 7.45393 3 5.5H1C1 8.04607 2.25438 10.624 3.55179 12.5052C4.21003 13.4597 4.90928 14.2786 5.52684 14.8704C5.83394 15.1647 6.13858 15.42 6.42272 15.609C6.56468 15.7034 6.71878 15.7929 6.87906 15.8617C7.02806 15.9256 7.24664 16 7.5 16V14ZM8 5.5C8 5.77614 7.77614 6 7.5 6V8C8.88071 8 10 6.88071 10 5.5H8ZM7.5 5C7.77614 5 8 5.22386 8 5.5H10C10 4.11929 8.88071 3 7.5 3V5ZM7 5.5C7 5.22386 7.22386 5 7.5 5V3C6.11929 3 5 4.11929 5 5.5H7ZM7.5 6C7.22386 6 7 5.77614 7 5.5H5C5 6.88071 6.11929 8 7.5 8V6Z"
      fill={color}
      mask="url(#path-1-inside-1)"
    />
  </svg>
);

export const ReportIcon = ({ width = 18, height = 18 }: IconProps) => (
  <svg width={width} height={height} viewBox="0 0 11 16">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.5 0C10.2238 0 9.99998 0.223858 9.99998 0.5V1.20463C8.40471 0.255115 6.95234 0.877555 5.49998 1.49999C4.04762 2.12243 2.59526 2.74487 1 1.79534C0.673078 1.60075 0.340155 1.34014 0 0.999987V2.32547V8.99999C1.99999 11 3.74998 10.25 5.49998 9.49999C6.95234 8.87755 8.40471 8.25511 9.99998 9.20463V15.5C9.99998 15.7761 10.2238 16 10.5 16C10.7761 16 11 15.7761 11 15.5V9.99997C11 9.99998 11 9.99998 11 9.99999V8.67451V1.99999C11 1.99998 11 1.99997 11 1.99997V0.5C11 0.223858 10.7761 0 10.5 0ZM9.99998 2.43513V8.08078C9.37967 7.80681 8.75325 7.69756 8.12178 7.71934C7.02616 7.75712 6.00216 8.19642 5.17679 8.55052L5.10607 8.58085C4.19331 8.97203 3.49465 9.2582 2.80928 9.28183C2.28494 9.29991 1.69777 9.16223 1 8.56484V2.91919C1.62031 3.19317 2.24673 3.30242 2.8782 3.28064C3.97381 3.24287 4.9978 2.80356 5.82317 2.44947L5.8939 2.41914C6.80666 2.02796 7.50533 1.74178 8.1907 1.71815C8.71504 1.70007 9.30221 1.83775 9.99998 2.43513Z"
    />
  </svg>
);

type IconPathProps = {
  color: string;
};

export const BehanceIcon = ({ color }: IconPathProps) => (
  <>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M33.7509 20.2405C33.5331 19.4332 33.184 18.7108 32.6933 18.0832C32.2025 17.4524 31.5804 16.949 30.8165 16.5764C30.0527 16.2005 29.161 16.0142 28.1449 16.0142C27.2221 16.0142 26.3926 16.1678 25.6357 16.475C24.8822 16.7856 24.2324 17.2072 23.6863 17.7433C23.1403 18.2761 22.7255 18.9134 22.4283 19.6489C22.1345 20.3843 21.9824 21.1786 21.9824 22.0285C21.9824 22.9077 22.1276 23.7184 22.4145 24.4538C22.7048 25.1892 23.1126 25.8168 23.6345 26.3496C24.1737 26.8791 24.8131 27.2844 25.5769 27.5721C26.3442 27.8565 27.1944 28.0035 28.1414 28.0035C29.4997 28.0035 30.6679 27.7094 31.6218 27.1177C32.5896 26.5294 33.2981 25.5521 33.7682 24.1825H30.858C30.744 24.5355 30.4536 24.8722 29.9767 25.1892C29.4928 25.5063 28.9191 25.6665 28.252 25.6665C27.3257 25.6665 26.6103 25.4377 26.1161 24.9801C25.6218 24.5224 25.3004 23.6726 25.3004 22.7737H33.979C34.0412 21.8912 33.9652 21.0479 33.7509 20.2405ZM25.3039 20.8027C25.3177 20.5805 25.3695 20.3288 25.4525 20.0542C25.5389 19.7698 25.6806 19.5051 25.8949 19.2534C26.1092 19.005 26.3891 18.7958 26.7313 18.6258C27.0804 18.4558 27.5193 18.3709 28.0446 18.3709C28.8569 18.3709 29.5204 18.5931 29.9145 19.005C30.3085 19.4201 30.5953 20.0084 30.6748 20.806H25.3039V20.8027Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.1578 20.6259C19.6567 19.9297 18.8998 19.4427 17.8767 19.1649C18.6267 18.8282 19.1866 18.3967 19.5703 17.8705C19.9505 17.341 20.1406 16.6807 20.1406 15.8897C20.1406 15.1575 20.0127 14.5397 19.7604 14.0462C19.5012 13.5461 19.1382 13.1473 18.6751 12.8466C18.2051 12.5459 17.6486 12.3301 16.9988 12.1994C16.3422 12.0654 15.6233 12 14.8318 12H7V27.7058H15.0495C15.7961 27.7058 16.5219 27.6176 17.22 27.4411C17.9286 27.2646 18.5576 26.9933 19.1106 26.6272C19.6567 26.2611 20.0991 25.7904 20.424 25.2053C20.7454 24.6268 20.9078 23.9436 20.9078 23.1461C20.9078 22.1655 20.659 21.3254 20.1578 20.6259ZM10.6567 14.677H14.0783C14.4032 14.677 14.7177 14.6999 15.0184 14.7555C15.326 14.8045 15.5887 14.896 15.8237 15.03C16.0588 15.1575 16.2454 15.3406 16.3871 15.5759C16.5219 15.8112 16.591 16.112 16.591 16.478C16.591 17.1383 16.3871 17.6155 15.9689 17.9064C15.5438 18.2006 15.0081 18.3477 14.3583 18.3477H10.6567V14.677ZM17.0403 23.973C16.8917 24.2378 16.6912 24.447 16.4459 24.6006C16.2005 24.7575 15.9101 24.8654 15.5853 24.934C15.2638 25.0027 14.9217 25.0321 14.5622 25.0321H10.6567V20.7077H14.6313C15.4194 20.7077 16.0588 20.8776 16.5392 21.2241C17.0161 21.5739 17.2581 22.1491 17.2581 22.9565C17.2581 23.3683 17.1889 23.7115 17.0403 23.973Z"
      fill={color}
    />
    <path d="M31.3597 13.0522H24.627V14.6016H31.3597V13.0522Z" fill={color} />
  </>
);

export const DribbbleIcon = ({ color }: IconPathProps) => (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M20.0017 8C13.3762 8 8 13.3762 8 20.0017C8 26.6272 13.3762 32.0034 20.0017 32.0034C26.6136 32.0034 32.0034 26.6272 32.0034 20.0017C32.0034 13.3762 26.6136 8 20.0017 8ZM20.0017 30.2557C17.6328 30.2557 15.4447 29.4501 13.7141 28.095C13.895 27.7161 15.9772 23.7087 21.7562 21.6914C21.7835 21.6777 21.7938 21.6777 21.8211 21.6641C23.2684 25.4018 23.8521 28.5388 24.0091 29.4365C22.7734 29.969 21.4183 30.2557 20.0017 30.2557ZM25.7158 28.5012C25.61 27.8765 25.0639 24.8829 23.7258 21.1998C26.9413 20.6912 29.7505 21.5241 30.1021 21.6436C29.6584 24.4904 28.0165 26.9515 25.7158 28.5012ZM9.74427 20.0119V19.7013C10.188 19.715 15.158 19.7798 20.2748 18.2438C20.5752 18.8172 20.8482 19.4009 21.1077 19.988C20.978 20.0256 20.8346 20.0666 20.7049 20.1041C15.4208 21.8108 12.6082 26.4702 12.376 26.8593C10.7478 25.0502 9.74427 22.6437 9.74427 20.0119ZM27.9277 13.5332C29.358 15.2775 30.2182 17.5031 30.2455 19.9095C29.9075 19.8447 26.5214 19.1552 23.1114 19.5853C23.0329 19.4146 22.968 19.2337 22.8895 19.0528C22.6813 18.5578 22.4457 18.0492 22.2136 17.5679C25.9889 16.0319 27.7059 13.8165 27.9277 13.5332ZM15.6393 10.7342C15.9124 11.0994 17.7352 13.6356 19.4385 16.6565C14.6494 17.9332 10.4201 17.9058 9.96274 17.9058C10.6284 14.7279 12.7754 12.0859 15.6393 10.7342ZM20.0017 9.77158C22.6062 9.77158 24.9853 10.7478 26.7945 12.3487C26.6136 12.6082 25.0639 14.6801 21.4183 16.0455C19.7389 12.9597 17.8785 10.4338 17.5918 10.0447C18.3598 9.86033 19.1688 9.77158 20.0017 9.77158Z"
    fill={color}
  />
);

export const GitHubIcon = ({ color }: IconPathProps) => (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M25.069 37.9021C25.069 37.285 25.069 35.0637 25.069 32.3488C25.069 30.4977 24.4395 29.2636 23.6842 28.6465C28.2162 28.1529 33 26.4252 33 18.774C33 16.5527 32.2447 14.825 30.8599 13.3441C31.1117 12.8504 31.7411 10.7525 30.6081 8.03757C30.6081 8.03757 28.8456 7.54394 24.9431 10.1355C23.3065 9.64186 21.544 9.51845 19.7816 9.51845C18.0191 9.51845 16.2567 9.76526 14.6201 10.1355C10.9693 7.54394 9.20685 8.03757 9.20685 8.03757C8.07384 10.8759 8.82918 12.8504 9.08096 13.3441C7.82206 14.7015 6.94083 16.5527 6.94083 18.774C6.94083 26.4252 11.7246 28.1529 16.2567 28.77C15.6272 29.2636 15.1237 30.1274 14.9978 31.4849C13.8648 31.9785 10.8434 32.8424 9.08096 29.7572C9.08096 29.7572 7.94795 27.7827 5.93372 27.6593C5.93372 27.6593 3.91948 27.6593 5.80783 28.8934C5.80783 28.8934 7.19261 29.5104 8.07384 31.8551C8.07384 31.8551 9.33274 35.8042 14.9978 34.5701C14.9978 36.2978 14.9978 37.5319 14.9978 38.0255C14.9978 38.5191 14.6201 39.1362 13.613 39.0127C15.6272 39.6298 17.7673 40 20.0334 40C22.2994 40 24.4395 39.6298 26.4537 39.0127C25.4466 39.1362 25.069 38.5191 25.069 37.9021Z"
    fill={color}
  />
);

export const InstagramIcon = ({ color }: IconPathProps) => (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M20 8C16.742 8 16.3312 8.01404 15.0532 8.07373C13.7753 8.13341 12.9046 8.33353 12.1393 8.63195C11.3493 8.93739 10.6823 9.34816 10.0152 10.0152C9.34816 10.6823 8.93739 11.3528 8.63195 12.1393C8.33704 12.9011 8.13341 13.7753 8.07373 15.0532C8.01404 16.3312 8 16.742 8 20C8 23.258 8.01404 23.6688 8.07373 24.9468C8.13341 26.2247 8.33353 27.0954 8.63195 27.8607C8.93739 28.6507 9.34816 29.3177 10.0152 29.9848C10.6823 30.6518 11.3528 31.0626 12.1393 31.3681C12.9011 31.663 13.7753 31.8666 15.0532 31.9263C16.3347 31.986 16.742 32 20 32C23.258 32 23.6688 31.986 24.9468 31.9263C26.2247 31.8666 27.0954 31.6665 27.8607 31.3681C28.6507 31.0626 29.3177 30.6518 29.9848 29.9848C30.6518 29.3177 31.0626 28.6472 31.3681 27.8607C31.663 27.0989 31.8666 26.2247 31.9263 24.9468C31.986 23.6653 32 23.258 32 20C32 16.742 31.986 16.3312 31.9263 15.0532C31.8666 13.7753 31.6665 12.9046 31.3681 12.1393C31.0626 11.3493 30.6518 10.6823 29.9848 10.0152C29.3177 9.34816 28.6472 8.93739 27.8607 8.63195C27.0989 8.33353 26.2247 8.13341 24.9468 8.07373C23.6688 8.01404 23.258 8 20 8ZM20 10.1627C23.2054 10.1627 23.5846 10.1732 24.8485 10.2329C26.0176 10.2855 26.653 10.4822 27.0778 10.6472C27.6396 10.8648 28.0363 11.1246 28.4576 11.5459C28.8789 11.9672 29.1387 12.364 29.3564 12.9257C29.5214 13.347 29.7145 13.9824 29.7706 15.1551C29.8268 16.419 29.8408 16.8016 29.8408 20.0035C29.8408 23.2054 29.8303 23.5881 29.7706 24.852C29.718 26.0211 29.5214 26.6565 29.3564 27.0813C29.1387 27.6431 28.8789 28.0398 28.4576 28.4611C28.0363 28.8824 27.6396 29.1422 27.0778 29.3599C26.6565 29.5249 26.0211 29.718 24.8485 29.7741C23.5846 29.8303 23.2054 29.8444 20 29.8444C16.7946 29.8444 16.4154 29.8338 15.1516 29.7741C13.9824 29.7215 13.347 29.5249 12.9222 29.3599C12.3604 29.1422 11.9637 28.8824 11.5424 28.4611C11.1211 28.0398 10.8613 27.6431 10.6437 27.0813C10.4786 26.66 10.2855 26.0246 10.2294 24.852C10.1732 23.5881 10.1592 23.2054 10.1592 20.0035C10.1592 16.8016 10.1697 16.419 10.2294 15.1551C10.282 13.986 10.4786 13.3505 10.6437 12.9257C10.8613 12.364 11.1211 11.9672 11.5424 11.5459C11.9637 11.1246 12.3604 10.8648 12.9222 10.6472C13.3435 10.4822 13.9789 10.2891 15.1516 10.2329C16.4154 10.1732 16.7946 10.1627 20 10.1627ZM20 13.8385C16.598 13.8385 13.8385 16.598 13.8385 20C13.8385 23.402 16.598 26.1615 20 26.1615C23.402 26.1615 26.1615 23.402 26.1615 20C26.1615 16.598 23.402 13.8385 20 13.8385ZM20 23.9988C17.7917 23.9988 16.0012 22.2083 16.0012 20C16.0012 17.7917 17.7917 16.0012 20 16.0012C22.2083 16.0012 23.9988 17.7917 23.9988 20C23.9988 22.2083 22.2083 23.9988 20 23.9988ZM27.8467 13.5927C27.8467 14.3897 27.2007 15.0322 26.4073 15.0322C25.6103 15.0322 24.9678 14.3862 24.9678 13.5927C24.9678 12.7993 25.6138 12.1533 26.4073 12.1533C27.2007 12.1533 27.8467 12.7993 27.8467 13.5927Z"
    fill={color}
  />
);

export const LinkedInIcon = ({ color }: IconPathProps) => (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M14.2218 30V15.8329H9.28935V30.0032H14.2218V30ZM32 30V21.8751C32 17.5234 29.5674 15.4986 26.324 15.4986C23.7098 15.4986 22.5355 16.8742 21.8795 17.8384V15.8329H16.9504C17.0143 17.1634 16.9504 30.0032 16.9504 30.0032H21.8795V22.0872C21.8795 21.663 21.9097 21.2387 22.041 20.9366C22.3976 20.0914 23.2085 19.214 24.5711 19.214C26.3543 19.214 27.0676 20.5124 27.0676 22.4183V30H32ZM11.7892 9C10.1036 9 9 10.0606 9 11.449C9 12.8085 10.0699 13.8981 11.7253 13.8981H11.7556C13.4748 13.8981 14.5448 12.8085 14.5448 11.449C14.5145 10.0606 13.4782 9.00321 11.7892 9Z"
    fill={color}
  />
);

export const MediumIcon = ({ color }: IconPathProps) => (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M21.7938 20.5C21.7938 16.3585 18.2596 13 13.8952 13C9.53084 13 6 16.3585 6 20.5C6 24.6415 9.53418 28 13.8985 28C18.2596 28 21.7938 24.6415 21.7938 20.5ZM30.4592 20.5C30.4592 16.6006 28.6921 13.4403 26.5116 13.4403C24.331 13.4403 22.5639 16.6006 22.5639 20.5C22.5639 24.3994 24.3277 27.5597 26.5082 27.5597C28.6887 27.5597 30.4592 24.3994 30.4592 20.5ZM34 20.5C34 17.0063 33.3799 14.1761 32.6097 14.1761C31.8428 14.1761 31.2227 17.0094 31.2227 20.5C31.2227 23.9906 31.8428 26.8239 32.6097 26.8239C33.3799 26.8239 34 23.9937 34 20.5Z"
    fill={color}
  />
);

export const TwitterIcon = ({ color }: IconPathProps) => (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M15.4713 31C25.6669 31 31.2428 22.9188 31.2428 15.9139C31.2428 15.6825 31.2428 15.4511 31.2313 15.2307C32.3103 14.4814 33.255 13.5484 34 12.4831C33.0131 12.9019 31.9417 13.1884 30.8165 13.3169C31.9647 12.6558 32.8403 11.6236 33.255 10.382C32.1875 10.9881 31.0009 11.4252 29.7374 11.6677C28.7237 10.6391 27.2874 10 25.6899 10C22.6332 10 20.1486 12.3766 20.1486 15.3005C20.1486 15.7193 20.1947 16.1233 20.2984 16.509C15.6902 16.2886 11.6082 14.1765 8.87399 10.9661C8.40165 11.7485 8.12516 12.6594 8.12516 13.6292C8.12516 15.4658 9.10055 17.0931 10.5982 18.0371C9.69194 18.015 8.83943 17.7726 8.0906 17.3759V17.442C8.0906 20.0133 9.99915 22.1475 12.5375 22.6433C12.0767 22.7646 11.5851 22.8307 11.0782 22.8307C10.7211 22.8307 10.3755 22.7976 10.0337 22.7315C10.7365 24.8436 12.7794 26.3717 15.2064 26.4158C13.3093 27.8337 10.9208 28.6822 8.32101 28.6822C7.87171 28.6822 7.43778 28.6601 7 28.605C9.42697 30.1221 12.3455 31 15.4713 31Z"
    fill={color}
  />
);

export const VimeoIcon = ({ color }: IconPathProps) => (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M30.9895 14.86C30.8841 17.2221 29.2516 20.4581 26.0954 24.5678C22.8303 28.8552 20.0708 31.0007 17.8133 31.0007C16.4125 31.0007 15.2294 29.6935 14.2639 27.0827C13.6179 24.6886 12.9719 22.291 12.3259 19.8968C11.6062 17.2861 10.8373 15.9789 10.0123 15.9789C9.83324 15.9789 9.2048 16.3625 8.12697 17.1227L7 15.6485C8.18315 14.5971 9.35225 13.5421 10.5038 12.4872C12.0837 11.1054 13.2703 10.3808 14.0603 10.3062C15.928 10.125 17.0761 11.4144 17.5079 14.1815C17.9748 17.1653 18.2978 19.0195 18.4769 19.7441C19.0176 22.2199 19.6074 23.456 20.2534 23.456C20.7554 23.456 21.5102 22.6533 22.5178 21.0477C23.5219 19.4422 24.0591 18.2203 24.1328 17.382C24.2768 15.9966 23.7361 15.304 22.5178 15.304C21.9421 15.304 21.3523 15.439 20.7414 15.7018C21.921 11.7945 24.175 9.89769 27.5032 10.0043C29.9643 10.0788 31.1299 11.695 30.9895 14.86Z"
    fill={color}
  />
);

export const HeartIcon = () => (
  <svg
    width="16"
    height="14"
    viewBox="0 0 16 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.1665 14C8.10019 14 8.03466 13.9827 7.97466 13.9481C7.90045 13.9053 6.13835 12.8767 4.3494 11.1918C3.29071 10.1953 2.44598 9.17577 1.8365 8.16118C1.05966 6.86741 0.666504 5.57612 0.666504 4.32353C0.666504 1.93941 2.52571 0 4.81124 0C5.58492 0 6.40677 0.302235 7.12519 0.851529C7.54519 1.17271 7.90282 1.55976 8.1665 1.97071C8.43019 1.55976 8.78782 1.17271 9.20782 0.851529C9.92624 0.302235 10.7481 0 11.5218 0C13.8073 0 15.6665 1.93941 15.6665 4.32353C15.6665 5.57612 15.2726 6.86741 14.4965 8.16118C13.8878 9.17577 13.0423 10.1953 11.9844 11.1918C10.1955 12.8767 8.43335 13.9053 8.35914 13.9481C8.29914 13.9827 8.23361 14 8.16729 14H8.1665Z"
      fill="#444444"
    />
  </svg>
);

export const FramerIcon = ({
  width = 18,
  height = 18,
  color = 'white',
}: IconProps) => (
  <svg width={width} height={height} viewBox="0 0 9 12" fill="none">
    <path
      d="M8.5 0V4H4.5L0.5 0H8.5ZM0.5 4H4.5L8.5 8H4.5V12L0.5 8V4Z"
      fill={color}
    />
  </svg>
);

export const RiveLogo = ({ height = 50, width }: IconProps) => (
  <svg width={width ?? height * 5.5} height={height} viewBox="0 0 275 50">
    <path
      d="M1.94852 0H29.897C33.0579 0 35.8508 0.661545 38.2757 1.98463C40.7438 3.26504 42.6707 5.03628 44.0563 7.29833C45.442 9.56039 46.1348 12.1852 46.1348 15.1729C46.1348 18.6726 45.1389 21.7029 43.147 24.2638C41.1552 26.7819 38.5138 28.5105 35.223 29.4494L46.3946 47.0551C46.9575 47.9087 47.0658 48.6129 46.7193 49.1677C46.4162 49.7226 45.7667 50 44.7708 50C44.2945 50 43.9264 49.9146 43.6666 49.7439C43.4501 49.5305 43.2336 49.2744 43.0171 48.9757L31.0661 30.1537H17.4913C16.4151 30.1537 15.5427 29.2938 15.5427 28.233C15.5427 27.1723 16.4151 26.3124 17.4913 26.3124H29.897C32.3218 26.3124 34.4436 25.8429 36.2622 24.904C38.1241 23.9223 39.5747 22.5992 40.6139 20.9347C41.6964 19.2702 42.2377 17.3496 42.2377 15.1729C42.2377 12.9535 41.6964 10.9902 40.6139 9.28297C39.5747 7.57575 38.1241 6.25267 36.2622 5.3137C34.4436 4.33205 32.3218 3.84123 29.897 3.84123L1.94852 3.84123C1.4289 3.84123 0.974278 3.64917 0.584564 3.26504C0.19485 2.88092 0 2.43278 0 1.92061C0 1.36577 0.194851 0.896287 0.584564 0.512165C0.974278 0.170723 1.4289 0 1.94852 0Z"
      fill="white"
    />
    <path
      d="M97.7825 50C97.2196 50 96.7433 49.8293 96.3536 49.4878C96.0071 49.1037 95.8339 48.6342 95.8339 48.0794V1.92061C95.8339 1.36577 96.0071 0.917625 96.3536 0.576184C96.7433 0.192061 97.2196 0 97.7825 0C98.3454 0 98.8 0.192061 99.1465 0.576184C99.5362 0.917625 99.731 1.36577 99.731 1.92061V48.0794C99.731 48.6342 99.5362 49.1037 99.1465 49.4878C98.8 49.8293 98.3454 50 97.7825 50Z"
      fill="white"
    />
    <path
      d="M169.849 50C169.026 50 168.441 49.5945 168.095 48.7836L148.61 3.137C148.177 2.15535 148.155 1.38711 148.545 0.832267C148.978 0.277422 149.562 0 150.298 0C151.121 0 151.749 0.448143 152.182 1.34443L169.914 43.2138L187.451 1.60051C187.883 0.533504 188.598 0 189.594 0C190.373 0 190.893 0.320102 191.153 0.960306C191.413 1.60051 191.369 2.32608 191.023 3.137L171.602 48.7836C171.386 49.2531 171.104 49.5732 170.758 49.7439C170.455 49.9146 170.152 50 169.849 50Z"
      fill="white"
    />
    <path
      d="M241.81 50C241.247 50 240.771 49.8293 240.381 49.4878C240.035 49.1037 239.861 48.6342 239.861 48.0794V1.92061C239.861 1.36577 240.035 0.917625 240.381 0.576184C240.771 0.192061 241.247 0 241.81 0H273.051C273.571 0 274.026 0.192061 274.415 0.576184C274.805 0.917625 275 1.36577 275 1.92061C275 2.43278 274.805 2.88092 274.415 3.26504C274.026 3.64917 273.571 3.84123 273.051 3.84123H243.758V23.0474H265.257C265.82 23.0474 266.275 23.2394 266.621 23.6236C267.011 23.965 267.206 24.4131 267.206 24.968C267.206 25.5228 267.011 25.9923 266.621 26.3764C266.275 26.7606 265.82 26.9526 265.257 26.9526H243.758V46.1588H273.051C273.571 46.1588 274.026 46.3508 274.415 46.735C274.805 47.1191 275 47.5672 275 48.0794C275 48.6342 274.805 49.1037 274.415 49.4878C274.026 49.8293 273.571 50 273.051 50H241.81Z"
      fill="white"
    />
  </svg>
);

export const BackArrow = ({ color = 'white', width = 20 }: IconProps) => (
  <svg width={width} viewBox="0 0 15 9" fill="none">
    <path
      d="M14.5 4.5H0.499999"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.00006 8L0.500061 4.5L4.00006 1"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
